import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _hoisted_1 = { class: "pr-default" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Voltar para o site", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "pr-default__container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "debug-link",
      href: "/cadastro/psicologos/dados-profissionais"
    }, "Psicologia")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "debug-link",
      href: "/cadastro/nutricionistas/dados-profissionais"
    }, "Nutrição")
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://orienteme.com.br/termos-de-uso/",
  target: "_blank",
  style: {"margin-right":"20px"}
}, "Termos de uso", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://orienteme.com.br/politica-de-privacidade/",
  target: "_blank"
}, "Politica de privacidade", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Steps = _resolveComponent("Steps")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "pr-default__header" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          class: "pr-default__goback",
          span: 12
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = () => _ctx.goTo(_ctx.wesiteUrl))
            }, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              (_ctx.isDebug)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "pr-default__box-card" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_Steps, {
            steps: Object.values(_ctx.steps),
            activeStep: _ctx.activeStep
          }, null, 8, ["steps", "activeStep"]), [
            [_vShow, _ctx.stepVisible]
          ]),
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { class: "pr-default__footer" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_popover, {
            placement: "top-start",
            width: 100,
            trigger: "hover",
            content: _ctx.version
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "pr-default__copy",
                span: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.currentYear) + "©", 1),
                  _createTextVNode(" orienteme ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_col, {
            class: "pr-default__links",
            span: 12
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}